import { gql, useSubscription } from '@apollo/client';
import { StockLocationFragments } from '../../graphql/stockLocation.graphql';
import { StockLocation } from '../../types/stock_location/stockLocation';
import { useContext, useEffect } from 'react';
import { CompanyContext } from '../../context/CompanyContext';
import React from 'react';
import { forNotification } from '../Common/forNotification';
import { useAppDispatch } from '../../ui/pages/store';
import { stockLocationSlice } from '../../providers/StockLocationProvider';

const stockLocationSubscription = gql`
  subscription StockLocationNotification($companyId: String!) {
    stockLocationNotification(companyId: $companyId) {
      companyId
      entities {
        ...StockLocation
      }
      topic
      date
    }
  }
  ${StockLocationFragments.stockLocation}
`;

export class StockLocationNotificationResponse extends forNotification<StockLocation>('stockLocationNotification') {}

export default function StockLocationNotification({}) {
  const { currentCompany } = useContext(CompanyContext);
  const dispatch = useAppDispatch();

  if (!currentCompany) return null;

  const { data: stockLocationNotification } = useSubscription<StockLocationNotificationResponse>(
    stockLocationSubscription,
    { variables: { companyId: currentCompany.id } },
  );

  const handleStockLocationNotification = (notification?: StockLocationNotificationResponse) => {
    if (!notification?.stockLocationNotification) return;
    const stockLocationNotification = notification.stockLocationNotification;

    switch (stockLocationNotification.topic) {
      case 'CREATE':
      case 'UPDATE':
        dispatch(stockLocationSlice.actions.add(stockLocationNotification.entities));
        break;
      case 'DELETE':
        dispatch(stockLocationSlice.actions.delete(stockLocationNotification.entities));
        break;
    }
  };

  useEffect(() => {
    handleStockLocationNotification(stockLocationNotification);
  }, [stockLocationNotification]);

  return <></>;
}
